import {
  HomeIcon,
  CalendarDaysIcon,
  BookOpenIcon,
  FolderOpenIcon,
  DocumentTextIcon,
  ChartBarIcon,
  CurrencyDollarIcon,
  TableCellsIcon,
  ServerStackIcon,
  MicrophoneIcon,
  AcademicCapIcon,
  TrophyIcon,
  QuestionMarkCircleIcon,
  UsersIcon,
} from "@heroicons/react/24/outline";
import { NavigationItem } from "./types";

const navigation: NavigationItem[] = [
  {
    name: "Home",
    href: "/hub",
    icon: HomeIcon,
    current: false,
    internalName: "home",
  },
  {
    name: "Event Directory",
    href: "/event-registration/events",
    icon: CalendarDaysIcon,
    current: false,
    internalName: "event-directory",
    permissions: ["administration-events"],
    isCertainPathOnly: true,
  },
  {
    name: "Resource Library",
    href: "/hub/resources",
    icon: BookOpenIcon,
    current: false,
    internalName: "resource_library",
  },
  {
    name: "News",
    href: "/hub/news",
    icon: DocumentTextIcon,
    current: false,
    internalName: "news",
  },
  {
    name: "Podcasts",
    href: "/hub/podcasts",
    icon: MicrophoneIcon,
    current: false,
    internalName: "podcasts",
  },
  {
    name: "Financial Reports",
    href: "/hub/financial-reports",
    icon: FolderOpenIcon,
    current: false,
    internalName: "financial_reports",
    permissions: [
      "financial-reports-monthly-balance",
      "financial-reports-p-and-l-report-builder",
      "financial-reports-transaction-list",
    ],
    children: [
      {
        name: "Monthly Balance Sheet",
        href: "/hub/financial-reports/monthly-balance-sheet",
        icon: ChartBarIcon,
        current: false,
        internalName: "monthly_balance_sheet",
        permissions: ["financial-reports-monthly-balance"],
      },
      {
        name: "Profit and Loss",
        href: "/hub/financial-reports/profit-and-loss-builder",
        icon: CurrencyDollarIcon,
        current: false,
        internalName: "profit_and_loss_builder",
        permissions: ["financial-reports-p-and-l-report-builder"],
      },
      {
        name: "Transaction List",
        href: "/hub/financial-reports/transaction-list",
        icon: TableCellsIcon,
        current: false,
        internalName: "transaction_list",
        permissions: ["financial-reports-transaction-list"],
      },
    ],
  },
  {
    name: "Data Connector",
    href: "/hub/data-connector",
    icon: ServerStackIcon,
    current: false,
    internalName: "data_connector",
    permissions: ["data-connector"],
  },
  {
    name: "Training",
    href: process.env.REACT_APP_MEMBER_PORTAL_URL || "",
    icon: AcademicCapIcon,
    current: false,
    internalName: "training",
    permissions: ["training-portal"],
  },
  {
    name: "Scoreboard",
    href: process.env.REACT_APP_SCOREBOARD_URL || "",
    icon: TrophyIcon,
    current: false,
    internalName: "scoreboard",
    permissions: ["scoreboard"],
  },
  {
    name: "Partner Network",
    href: process.env.REACT_APP_PARTNER_NETWORK_URL || "",
    icon: UsersIcon,
    current: false,
    internalName: "partner-network",
    permissions: ["partner-network"],
  },
  {
    name: "Your Coaching Team",
    href: "/hub/resources/your-certainpath-team",
    icon: QuestionMarkCircleIcon,
    current: false,
    internalName: "help",
  },
];

const hubConfig = {
  sectionName: "hub",
  defaultRoute: "/hub",
  navigation,
};

export default hubConfig;
